import { MobileErrorCode } from '../../../shared/constants/mobile-app';

export const mobileErrorTranslationKey: Record<MobileErrorCode, string> = Object.freeze({
  [MobileErrorCode.APP_DEVICE_TYPE_MISMATCH]: 'device_api_error_app_device_type_mismatch',
  [MobileErrorCode.APP_SESSION_ALREADY_RUNNING]: 'device_api_error_app_session_already_running',
  [MobileErrorCode.APP_SESSION_NOT_FOUND]: 'device_api_error_app_session_not_found',
  [MobileErrorCode.APP_TARGET_DEVICE_TYPE_MISSING]: 'device_api_error_app_target_device_type_missing',
  [MobileErrorCode.FILE_NOT_FOUND]: 'device_api_error_file_not_found',
  [MobileErrorCode.FILE_SIZE_EXCEEDS_SYSTEM_LIMIT]: 'device_api_error_file_size_exceeds_system_limit',
  [MobileErrorCode.FILE_SIZE_IS_ZERO]: 'device_api_error_file_size_zero',
  [MobileErrorCode.FILE_TYPE_INVALID]: 'device_api_error_file_type_invalid',
  [MobileErrorCode.ID_NOT_FOUND]: 'device_api_error_id_not_found',
  [MobileErrorCode.INVALID_EMULATOR_COMMAND]: 'device_api_error_invalid_emulator_command',
  [MobileErrorCode.IOS_APP_ZIP_FILE_DECOMPRESSION_FAILED]: 'device_api_error_ios_zip_file_decompression_failed',
  [MobileErrorCode.IOS_APP_ZIP_FILE_MISSING_APP_FOLDER]: 'device_api_error_ios_zip_file_missing_app_folder',
  [MobileErrorCode.MOBILE_APP_HAS_OPEN_SESSIONS]: 'device_api_error_mobile_app_has_open_sessions',
  [MobileErrorCode.MOBILE_APP_NOT_FOUND]: 'device_api_error_mobile_app_not_found',
  [MobileErrorCode.MOBILE_APP_UPLOAD_FAILED]: 'device_api_error_mobile_app_upload_failed',
  [MobileErrorCode.MOBILE_APP_UPLOAD_IS_PENDING]: 'device_api_error_mobile_app_upload_is_pending',
  [MobileErrorCode.SAUCE_LABS_API_KEY_VALIDATION_FAILED]: 'sauce_labs_api_key_validation_failed',
  [MobileErrorCode.SAUCE_LABS_FILE_NOT_FOUND]: 'sauce_labs_file_not_found',
  [MobileErrorCode.SESSION_CONCURRENCY_LIMITS_EXCEEDED]: 'virtual_device_unavailable',
  [MobileErrorCode.SESSION_START_FAILED]: 'device_api_error_session_start_failed',
  [MobileErrorCode.UNSUPPORTED_DEVICE]: 'device_api_error_unsupported_device',
  [MobileErrorCode.UNSUPPORTED_PLATFORM]: 'device_api_error_unsupported_platform',
  [MobileErrorCode.WEBSOCKET_CONNECTION_ERROR]: 'websocket_connection_error',
  [MobileErrorCode.WEBSOCKET_CONNECTION_REPLACED]: 'websocket_connection_replaced',
  [MobileErrorCode.REAL_DEVICE_NOT_AVAILABLE]: 'real_device_unavailable',
});
